<button type="button" class="btn p-2 shadow-sm"
  [ngClass]="[outline ? styles[type]?.classOutline : styles[type]?.class, customClasses]"
  [disabled]="disabled"
  [hidden]="hidden"
  (click)="click()">
  @if (type != s1ButtonType.Next) {
    <i class="{{ icon ? icon : styles[type]?.icon }}"></i>
    } @if (!onlyIcon) {
    <span> {{ (label ? label : styles[type]?.label) | translate }} </span>
    } @if (type == s1ButtonType.Next) {
    <i class="{{ icon ? icon : styles[type]?.icon }}"></i>
  }
</button>